import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8 10C8 8.89543 8.89543 8 10 8H14C15.1046 8 16 8.89543 16 10V14C16 15.1046 15.1046 16 14 16H10C8.89543 16 8 15.1046 8 14V10Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "DummyIconSmFill"
);
